export const AUTH_ACTIONS = {
  SET_STATE: 'auth/setState',
  GET_CURRENT_ACCOUNT: 'auth/currectAccount',
  LOGIN: 'admin/login',
  REGISTER: 'admin/register',
  LOGOUT: 'admin/logout',
  DESTROY: "admin/destroy"
};
